import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ChangeMgmtComponent} from 'src/app/main/change-mgmt/change-mgmt.component';

const routes: Routes = [
  {
    path: '',
    component: ChangeMgmtComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangeMgmtRoutingModule {
}
